/* eslint-disable operator-linebreak */
/* eslint-disable no-param-reassign */
/**
 * @package soulgood-custom
 *
 * Entry point for Javascript package
 */

import ScrollOut from 'scroll-out';
// import Parallax from 'parallax-js';

// const scene = document.querySelector('.dstijl-grid-system__wrapper');
// if (scene) {
//   const parallaxInstance = new Parallax(scene);
// }

ScrollOut({});

require('./components/dstijl.instaGrid');
require('./components/mobileMenu');

// Initialize the application
// Start all required functions in here
function soulInit() {
  // @ts-ignore Initialize lazy loading
  new LazyLoad();
}

// Check if polyfill loading is needed
if (
  'fetch' in window &&
  'Intl' in window &&
  'URL' in window &&
  'Map' in window &&
  'forEach' in NodeList.prototype &&
  'startsWith' in String.prototype &&
  'endsWith' in String.prototype &&
  'includes' in String.prototype &&
  'includes' in Array.prototype &&
  'assign' in Object &&
  'entries' in Object &&
  'keys' in Object
) {
  soulInit();
} else {
  // @ts-ignore Load polyfills
  import('./polyfills.ts').then(soulInit);
}
